export const MESSAGES = {
    SIGN_UP_SUCCESS: "Sign up successfull. Please Login!",
    SIGN_UP_FAILURE: "User already exist , Kindly Login !",
    LOGIN_SUCCESS: "Login successfull",
    LOGIN_FAILURE: "Incorrect email or password",
    INVALID_EMAIL: "Invalid email",
    EMAIL_VALIDATION: "Incorrect Email , must follow @gmail.com",
    PASSWORD_VALIDATION: "Password must be at least 6 characters",
    REQUIRED:"Required",
    SOMETHING_WENT_WRONG:"Something went Wrong",
    FIRST_NAME_VALIDATION:"First name must contain only letters",
  LAST_NAME_VALIDATION: "Last name must contain only letters",
    SESSION_TIMEOUT : "Session Expired",
  }; 
  
export const ROLES ={
  ADMIN: "ADMIN",
  USER: "USER",
  CUSTOMER :"CUSTOMER"
}

export const COMPANY_NAME = "RoofTop SolarOps";

export const ASC = "asc";
export const DESC = "desc";
export const NO_DATA_AVAILABLE = "No data available!";